import * as Immutable from "immutable";
export default ({
  title,
  description,
  defaultRoles = Immutable.List(),
  defaultUserTimezone,
  config: {
    servers = [],
    systemUserDn,
    transportSecurity,
    emailAttributes,
    userFullNameAttribute,
    userNameAttribute,
    userSearchBase,
    userSearchPattern,
    userUniqueIdAttribute,
    verifyCertificates
  }
}) => ({
  title,
  description,
  defaultRoles: defaultRoles.join(),
  defaultUserTimezone,
  serverHost: servers[0].host,
  serverPort: servers[0].port,
  systemUserDn,
  transportSecurity,
  userFullNameAttribute,
  emailAttributes,
  userNameAttribute,
  userSearchBase,
  userSearchPattern,
  userUniqueIdAttribute,
  verifyCertificates
});
